import React from "react";
import { motion } from "framer-motion";
import {
  FaMapMarkerAlt,
  FaCode,
  FaUsers,
  FaRocket,
  FaLanguage,
  FaCloud,
} from "react-icons/fa";
import { sectionVariants } from "../../constants/animations";
import { STATS } from "./About.constants";

const About: React.FC = () => {
  return (
    <motion.section
      variants={sectionVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      className="py-20 px-6"
    >
      <div className="max-w-5xl mx-auto">
        <h2 className="text-4xl font-bold mb-12 text-center gradient-text">
          About Me
        </h2>
        <div className="glass rounded-2xl p-8 gradient-border">
          <div className="grid md:grid-cols-3 gap-8">
            <div className="md:col-span-2">
              <h3 className="text-2xl font-bold mb-4 text-blue-400">
                Professional Summary
              </h3>
              <p className="text-lg text-slate-300 leading-relaxed mb-4">
                Senior Software Engineer with 17+ years of experience in web
                development. Currently at Proprio Cloud Solutions, building
                embedded React applications for NetSuite with Redux state
                management.
              </p>
              <p className="text-lg text-slate-300 leading-relaxed mb-4">
                Former Department Lead at Dynatech where I managed 100+
                developers across multiple teams. Led the rebuilding of
                Skyluxtravel.com, which was nominated as one of the best travel
                projects in the world in 2019.
              </p>
              <p className="text-lg text-slate-300 leading-relaxed">
                Experienced with React, Vue.js, Next.js, NestJS, TypeScript, and
                cloud platforms (Azure, AWS). Co-founded MadMasters, an
                outsourcing company specializing in complex animation projects.
                Also worked as a programming instructor.
              </p>
            </div>
            <div>
              <h3 className="text-2xl font-bold mb-4 text-purple-400">
                Quick Facts
              </h3>
              <ul className="space-y-3">
                <li className="flex items-center gap-3 text-slate-300">
                  <FaMapMarkerAlt className="text-blue-400" />
                  <span>Calgary, Canada</span>
                </li>
                <li className="flex items-center gap-3 text-slate-300">
                  <FaCode className="text-blue-400" />
                  <span>17+ Years Coding</span>
                </li>
                <li className="flex items-center gap-3 text-slate-300">
                  <FaUsers className="text-blue-400" />
                  <span>Led 100+ Developers</span>
                </li>
                <li className="flex items-center gap-3 text-slate-300">
                  <FaRocket className="text-blue-400" />
                  <span>Co-Founder Experience</span>
                </li>
                <li className="flex items-center gap-3 text-slate-300">
                  <FaLanguage className="text-blue-400" />
                  <span>3 Languages</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8">
            {STATS.map((stat, index) => (
              <motion.div
                key={stat.label}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ delay: stat.delay }}
                viewport={{ once: true }}
                className="text-center p-4 rounded-xl bg-slate-800/50"
              >
                {stat.icon === FaCode ? (
                  <FaCode className="text-3xl mx-auto mb-2 text-blue-400" />
                ) : (
                  <FaCloud className="text-3xl mx-auto mb-2 text-blue-400" />
                )}
                <p className="text-sm text-slate-400">{stat.label}</p>
                <p className="text-xl font-bold text-white">{stat.value}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default About;
